import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const SimpleArrowDownIcon: React.FC<IconProps> = ({
  color = "black",
  withBackground,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <path
            d="M9.228 12.234a.762.762 0 0 1 1.1 0L16 18.068l5.672-5.834a.762.762 0 0 1 1.1 0 .815.815 0 0 1 0 1.131l-6.222 6.4a.762.762 0 0 1-1.1 0l-6.222-6.4a.815.815 0 0 1 0-1.13Z"
            fill={color}
          />
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
          backgroundGray: withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
